import React from 'react';
import { Grid, InputLabel, OutlinedInput } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PreviewIcon from '@mui/icons-material/Preview';
import DefaultUploadFile from '../../../components/default-upload-file';
import { FieldError } from '../../../components/form-page-parts';
import { dataGridDefaults } from '../../../components/list-grid-panel';
import { RowAction } from '../../../components/row-action';
import { DeleteAction } from '../../../components/row-actions';
import { IFileResponse } from '../../../model/scp/base/response/file-response';
import { LookupSelect, toLookupOptions } from './lookup-select';
import { FileAttachmentsService, useFileAttachments } from './use-file-attachments';

// Inclusão e listagem dos anexos publicados (IRP, compra e contrato compartilham o mesmo fluxo)
export function FileAttachmentsTable({ entityId, service, uploadId }: { entityId?: number; service: FileAttachmentsService; uploadId: string }) {
    const ctrl = useFileAttachments(entityId, service);
    const errors = ctrl.validationErrors;

    const columns: GridColDef<IFileResponse>[] = [
        { field: 'number', headerName: 'Nº', width: 80, sortable: false, disableColumnMenu: true, align: 'right', headerAlign: 'right' },
        { field: 'title', headerName: 'Título', flex: 1, minWidth: 280, sortable: false, disableColumnMenu: true },
        { field: 'documentTypeDescription', headerName: 'Tipo', flex: 1, minWidth: 160, sortable: false, disableColumnMenu: true },
        {
            field: 'actions', headerName: 'Ações', width: 100, sortable: false, disableColumnMenu: true,
            renderCell: (params) => (
                <React.Fragment>
                    <RowAction title="Visualizar arquivo" onClick={() => window.open(params.row.fileUrl, '_blank')} disabled={!params.row.fileUrl}>
                        <PreviewIcon fontSize="small" />
                    </RowAction>
                    <DeleteAction onClick={() => ctrl.deleteFile(params.row)} />
                </React.Fragment>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid container spacing={2} sx={{ my: 1 }}>
                <Grid item xs={12} sm={6} lg={3}>
                    <LookupSelect required label="Tipo de Arquivo" name="select-document-type-atachment" value={ctrl.fileRequest.documentTypeId} options={toLookupOptions(ctrl.typeDocument, false)} onChange={ctrl.handleOnChange} error={errors.documentTypeId} />
                </Grid>
                <Grid item xs={12} sm={6} lg={4}>
                    <InputLabel required>Título do Documento</InputLabel>
                    <OutlinedInput fullWidth autoComplete="off" name="input-title-atachment" value={ctrl.fileRequest.title || ''} onChange={ctrl.handleOnChange} error={!!errors.title} />
                    <FieldError message={errors.title} />
                </Grid>
                <Grid item xs={12} sm={8} lg={3}>
                    <InputLabel required>Arquivo (PDF, até 30 MB)</InputLabel>
                    <DefaultUploadFile props={{ id: uploadId, setFileUpload: ctrl.setFileUpload, file: ctrl.fileRequest.document, extensions: ['pdf'], maxFileSizeMb: 30, error: !!errors.document }} />
                    <FieldError message={errors.document} />
                </Grid>
                <Grid item xs={12} sm={4} lg={2}>
                    <InputLabel>&nbsp;</InputLabel>
                    <LoadingButton fullWidth variant="contained" size="large" startIcon={<PlaylistAddIcon />} loadingPosition="start" loading={ctrl.isSaving} onClick={ctrl.saveFile}>
                        Adicionar
                    </LoadingButton>
                </Grid>
            </Grid>
            <DataGrid
                {...dataGridDefaults}
                columns={columns}
                rows={ctrl.files}
                loading={ctrl.loading}
                getRowId={(row: IFileResponse) => row.number ?? 0}
                initialState={{ pagination: { paginationModel: { pageSize: 25, page: 0 } } }}
            />
        </React.Fragment>
    );
}
